import {
    TypeProductCardWithoutUnresolvableLinksResponse,
    TypeProductContentHousingWithoutUnresolvableLinksResponse,
} from '@/features/contentful/_generated';
import ContentBlockWithTile from '@/features/contentful/components/ContentBlockWithTile/ContentBlockWithTile';
import { TIconTile } from '@/features/contentful/components/ContentBlockWithTile/TileWithIcIcon';
import React from 'react';

interface IIconCardProps {
    component: TypeProductContentHousingWithoutUnresolvableLinksResponse;
    id?: string;
}

const IconCard: React.FC<IIconCardProps> = ({ id, component: { fields } }) => {
    const items: TIconTile[] = fields?.ourComponent?.map((item) => {
        const productItem = item as TypeProductCardWithoutUnresolvableLinksResponse;
        return {
            id,
            title: productItem?.fields?.title ?? '',
            image: productItem?.fields?.icon?.fields?.file
                ? `https:${productItem?.fields?.icon?.fields?.file?.url}?fm=webp`
                : undefined,
            summaryDoc: productItem?.fields?.content,
        };
    });

    return (
        <ContentBlockWithTile
            title={fields.title}
            items={items}
            paddingTop={fields?.paddingTop}
            paddingBottom={fields?.paddingBottom}
            bgColor={fields?.backgroundColor}
        />
    );
};

export default IconCard;
